import { request } from '@/common/services/request';

const getPayloadData = (payload) => payload?.data || payload || {};

const toProTableResult = (result) => ({
  data: result.data || [],
  success: true,
  total: result.meta?.total || 0,
});

export async function queryTraceAccounts(params) {
  const result = await request('/api/trace/admin/accounts', {
    method: 'GET',
    params,
  });
  return toProTableResult(result);
}

export async function fetchTraceAccount(payload) {
  const data = getPayloadData(payload);
  return request('/api/trace/admin/accounts/fetch', {
    method: 'POST',
    params: {
      accountId: data.id,
    },
  });
}

export async function queryTraceAccountLogs(params) {
  const result = await request('/api/trace/admin/account-logs', {
    method: 'GET',
    params,
  });
  return toProTableResult(result);
}

export async function queryTraceContentLogs(params) {
  const result = await request('/api/trace/admin/content-logs', {
    method: 'GET',
    params,
  });
  return toProTableResult(result);
}

export async function queryTraceCommentLogs(params) {
  const result = await request('/api/trace/admin/comment-logs', {
    method: 'GET',
    params,
  });
  return toProTableResult(result);
}
